import { connect } from "react-redux";
import PrintNotes from "../components/PrintNotes";
var mapStateToProps = function(state, ownProps) {
    return {
        cbookName: state.cbook && state.cbook.name,
        nodeNames: ownProps.nodeIds && !!ownProps.nodeIds.length ? state.nodes.filter(function(n) {
            return ownProps.nodeIds.indexOf(n.id) > -1;
        }).map(function(n) {
            return n.name;
        }).join(", ") : ""
    };
};
export default connect(mapStateToProps)(PrintNotes);
